import baoRouter from "./../services/bao-router";
export default function (tabPage) {
    setTimeout(function () {
        tabPage.$TabController.RemoveTab(tabPage);
    }, 450);
    baoRouter.setHash("InstructionBook");
}